import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { scanService } from 'src/services/scan.service'

export const useQRCodeScan = () => {
  const [t] = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(async (payload: unknown) => {
    if (typeof payload !== 'string') {
      enqueueSnackbar(t('scan-form-qr-code-error'), { variant: 'error' })
      return null
    }

    return scanService.scanQrCode({ payload: payload as string })
  })
}
